<template>
  <div v-if="order.actions">
    <v-sheet class="pt-1 transparent-background-color d-inline-block">
      <v-tooltip
        top
        v-if="showView && $permission.permissionAllow('ReturnOrders', 'view')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            :href="($route.path.startsWith('/return-orders-approve')
                ? '/#/return-orders-approve/'
                : '/#/return-orders/')  + order.id"
          >
            <v-icon x-small class="pe-1">fa-align-left</v-icon>
            {{ $t("Opt.details") }}
          </v-btn>
        </template>
        <span>{{ $t("CRUD.viewInfo", [$t("ReturnOrder.ObjectName")]) }}</span>
      </v-tooltip>
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: "OrderActions",

  components: {
  },

  props: {
    order: Object,
    detailMode: Boolean,
    showView: Boolean,
  },

  computed: {},

  data: () => ({
  }),

  methods: {
  },
};
</script>